export function fullCountryName(country) {
  let countryList = [
    {
      name: "Afghanistan",
      "alpha-2": "AF",
    },
    {
      name: "Åland Islands",
      "alpha-2": "AX",
    },
    {
      name: "Albania",
      "alpha-2": "AL",
    },
    {
      name: "Algeria",
      "alpha-2": "DZ",
    },
    {
      name: "American Samoa",
      "alpha-2": "AS",
    },
    {
      name: "Andorra",
      "alpha-2": "AD",
    },
    {
      name: "Angola",
      "alpha-2": "AO",
    },
    {
      name: "Anguilla",
      "alpha-2": "AI",
    },
    {
      name: "Antarctica",
      "alpha-2": "AQ",
    },
    {
      name: "Antigua and Barbuda",
      "alpha-2": "AG",
    },
    {
      name: "Argentina",
      "alpha-2": "AR",
    },
    {
      name: "Armenia",
      "alpha-2": "AM",
    },
    {
      name: "Aruba",
      "alpha-2": "AW",
    },
    {
      name: "Australia",
      "alpha-2": "AU",
    },
    {
      name: "Austria",
      "alpha-2": "AT",
    },
    {
      name: "Azerbaijan",
      "alpha-2": "AZ",
    },
    {
      name: "Bahamas",
      "alpha-2": "BS",
    },
    {
      name: "Bahrain",
      "alpha-2": "BH",
    },
    {
      name: "Bangladesh",
      "alpha-2": "BD",
    },
    {
      name: "Barbados",
      "alpha-2": "BB",
    },
    {
      name: "Belarus",
      "alpha-2": "BY",
    },
    {
      name: "Belgium",
      "alpha-2": "BE",
    },
    {
      name: "Belize",
      "alpha-2": "BZ",
    },
    {
      name: "Benin",
      "alpha-2": "BJ",
    },
    {
      name: "Bermuda",
      "alpha-2": "BM",
    },
    {
      name: "Bhutan",
      "alpha-2": "BT",
    },
    {
      name: "Bolivia (Plurinational State of)",
      "alpha-2": "BO",
    },
    {
      name: "Bonaire, Sint Eustatius and Saba",
      "alpha-2": "BQ",
    },
    {
      name: "Bosnia and Herzegovina",
      "alpha-2": "BA",
    },
    {
      name: "Botswana",
      "alpha-2": "BW",
    },
    {
      name: "Bouvet Island",
      "alpha-2": "BV",
    },
    {
      name: "Brazil",
      "alpha-2": "BR",
    },
    {
      name: "British Indian Ocean Territory",
      "alpha-2": "IO",
    },
    {
      name: "Brunei Darussalam",
      "alpha-2": "BN",
    },
    {
      name: "Bulgaria",
      "alpha-2": "BG",
    },
    {
      name: "Burkina Faso",
      "alpha-2": "BF",
    },
    {
      name: "Burundi",
      "alpha-2": "BI",
    },
    {
      name: "Cabo Verde",
      "alpha-2": "CV",
    },
    {
      name: "Cambodia",
      "alpha-2": "KH",
    },
    {
      name: "Cameroon",
      "alpha-2": "CM",
    },
    {
      name: "Canada",
      "alpha-2": "CA",
    },
    {
      name: "Cayman Islands",
      "alpha-2": "KY",
    },
    {
      name: "Central African Republic",
      "alpha-2": "CF",
    },
    {
      name: "Chad",
      "alpha-2": "TD",
    },
    {
      name: "Chile",
      "alpha-2": "CL",
    },
    {
      name: "China",
      "alpha-2": "CN",
    },
    {
      name: "Christmas Island",
      "alpha-2": "CX",
    },
    {
      name: "Cocos (Keeling) Islands",
      "alpha-2": "CC",
    },
    {
      name: "Colombia",
      "alpha-2": "CO",
    },
    {
      name: "Comoros",
      "alpha-2": "KM",
    },
    {
      name: "Congo",
      "alpha-2": "CG",
    },
    {
      name: "Congo, Democratic Republic of the",
      "alpha-2": "CD",
    },
    {
      name: "Cook Islands",
      "alpha-2": "CK",
    },
    {
      name: "Costa Rica",
      "alpha-2": "CR",
    },
    {
      name: "Côte d'Ivoire",
      "alpha-2": "CI",
    },
    {
      name: "Croatia",
      "alpha-2": "HR",
    },
    {
      name: "Cuba",
      "alpha-2": "CU",
    },
    {
      name: "Curaçao",
      "alpha-2": "CW",
    },
    {
      name: "Cyprus",
      "alpha-2": "CY",
    },
    {
      name: "Czechia",
      "alpha-2": "CZ",
    },
    {
      name: "Denmark",
      "alpha-2": "DK",
    },
    {
      name: "Djibouti",
      "alpha-2": "DJ",
    },
    {
      name: "Dominica",
      "alpha-2": "DM",
    },
    {
      name: "Dominican Republic",
      "alpha-2": "DO",
    },
    {
      name: "Ecuador",
      "alpha-2": "EC",
    },
    {
      name: "Egypt",
      "alpha-2": "EG",
    },
    {
      name: "El Salvador",
      "alpha-2": "SV",
    },
    {
      name: "Equatorial Guinea",
      "alpha-2": "GQ",
    },
    {
      name: "Eritrea",
      "alpha-2": "ER",
    },
    {
      name: "Estonia",
      "alpha-2": "EE",
    },
    {
      name: "Eswatini",
      "alpha-2": "SZ",
    },
    {
      name: "Ethiopia",
      "alpha-2": "ET",
    },
    {
      name: "Falkland Islands (Malvinas)",
      "alpha-2": "FK",
    },
    {
      name: "Faroe Islands",
      "alpha-2": "FO",
    },
    {
      name: "Fiji",
      "alpha-2": "FJ",
    },
    {
      name: "Finland",
      "alpha-2": "FI",
    },
    {
      name: "France",
      "alpha-2": "FR",
    },
    {
      name: "French Guiana",
      "alpha-2": "GF",
    },
    {
      name: "French Polynesia",
      "alpha-2": "PF",
    },
    {
      name: "French Southern Territories",
      "alpha-2": "TF",
    },
    {
      name: "Gabon",
      "alpha-2": "GA",
    },
    {
      name: "Gambia",
      "alpha-2": "GM",
    },
    {
      name: "Georgia",
      "alpha-2": "GE",
    },
    {
      name: "Germany",
      "alpha-2": "DE",
    },
    {
      name: "Ghana",
      "alpha-2": "GH",
    },
    {
      name: "Gibraltar",
      "alpha-2": "GI",
    },
    {
      name: "Greece",
      "alpha-2": "GR",
    },
    {
      name: "Greenland",
      "alpha-2": "GL",
    },
    {
      name: "Grenada",
      "alpha-2": "GD",
    },
    {
      name: "Guadeloupe",
      "alpha-2": "GP",
    },
    {
      name: "Guam",
      "alpha-2": "GU",
    },
    {
      name: "Guatemala",
      "alpha-2": "GT",
    },
    {
      name: "Guernsey",
      "alpha-2": "GG",
    },
    {
      name: "Guinea",
      "alpha-2": "GN",
    },
    {
      name: "Guinea-Bissau",
      "alpha-2": "GW",
    },
    {
      name: "Guyana",
      "alpha-2": "GY",
    },
    {
      name: "Haiti",
      "alpha-2": "HT",
    },
    {
      name: "Heard Island and McDonald Islands",
      "alpha-2": "HM",
    },
    {
      name: "Holy See",
      "alpha-2": "VA",
    },
    {
      name: "Honduras",
      "alpha-2": "HN",
    },
    {
      name: "Hong Kong",
      "alpha-2": "HK",
    },
    {
      name: "Hungary",
      "alpha-2": "HU",
    },
    {
      name: "Iceland",
      "alpha-2": "IS",
    },
    {
      name: "India",
      "alpha-2": "IN",
    },
    {
      name: "Indonesia",
      "alpha-2": "ID",
    },
    {
      name: "Iran (Islamic Republic of)",
      "alpha-2": "IR",
    },
    {
      name: "Iraq",
      "alpha-2": "IQ",
    },
    {
      name: "Ireland",
      "alpha-2": "IE",
    },
    {
      name: "Isle of Man",
      "alpha-2": "IM",
    },
    {
      name: "Israel",
      "alpha-2": "IL",
    },
    {
      name: "Italy",
      "alpha-2": "IT",
    },
    {
      name: "Jamaica",
      "alpha-2": "JM",
    },
    {
      name: "Japan",
      "alpha-2": "JP",
    },
    {
      name: "Jersey",
      "alpha-2": "JE",
    },
    {
      name: "Jordan",
      "alpha-2": "JO",
    },
    {
      name: "Kazakhstan",
      "alpha-2": "KZ",
    },
    {
      name: "Kenya",
      "alpha-2": "KE",
    },
    {
      name: "Kiribati",
      "alpha-2": "KI",
    },
    {
      name: "Korea (Democratic People's Republic of)",
      "alpha-2": "KP",
    },
    {
      name: "Korea, Republic of",
      "alpha-2": "KR",
    },
    {
      name: "Kuwait",
      "alpha-2": "KW",
    },
    {
      name: "Kyrgyzstan",
      "alpha-2": "KG",
    },
    {
      name: "Lao People's Democratic Republic",
      "alpha-2": "LA",
    },
    {
      name: "Latvia",
      "alpha-2": "LV",
    },
    {
      name: "Lebanon",
      "alpha-2": "LB",
    },
    {
      name: "Lesotho",
      "alpha-2": "LS",
    },
    {
      name: "Liberia",
      "alpha-2": "LR",
    },
    {
      name: "Libya",
      "alpha-2": "LY",
    },
    {
      name: "Liechtenstein",
      "alpha-2": "LI",
    },
    {
      name: "Lithuania",
      "alpha-2": "LT",
    },
    {
      name: "Luxembourg",
      "alpha-2": "LU",
    },
    {
      name: "Macao",
      "alpha-2": "MO",
    },
    {
      name: "Madagascar",
      "alpha-2": "MG",
    },
    {
      name: "Malawi",
      "alpha-2": "MW",
    },
    {
      name: "Malaysia",
      "alpha-2": "MY",
    },
    {
      name: "Maldives",
      "alpha-2": "MV",
    },
    {
      name: "Mali",
      "alpha-2": "ML",
    },
    {
      name: "Malta",
      "alpha-2": "MT",
    },
    {
      name: "Marshall Islands",
      "alpha-2": "MH",
    },
    {
      name: "Martinique",
      "alpha-2": "MQ",
    },
    {
      name: "Mauritania",
      "alpha-2": "MR",
    },
    {
      name: "Mauritius",
      "alpha-2": "MU",
    },
    {
      name: "Mayotte",
      "alpha-2": "YT",
    },
    {
      name: "Mexico",
      "alpha-2": "MX",
    },
    {
      name: "Micronesia (Federated States of)",
      "alpha-2": "FM",
    },
    {
      name: "Moldova, Republic of",
      "alpha-2": "MD",
    },
    {
      name: "Monaco",
      "alpha-2": "MC",
    },
    {
      name: "Mongolia",
      "alpha-2": "MN",
    },
    {
      name: "Montenegro",
      "alpha-2": "ME",
    },
    {
      name: "Montserrat",
      "alpha-2": "MS",
    },
    {
      name: "Morocco",
      "alpha-2": "MA",
    },
    {
      name: "Mozambique",
      "alpha-2": "MZ",
    },
    {
      name: "Myanmar",
      "alpha-2": "MM",
    },
    {
      name: "Namibia",
      "alpha-2": "NA",
    },
    {
      name: "Nauru",
      "alpha-2": "NR",
    },
    {
      name: "Nepal",
      "alpha-2": "NP",
    },
    {
      name: "Netherlands",
      "alpha-2": "NL",
    },
    {
      name: "New Caledonia",
      "alpha-2": "NC",
    },
    {
      name: "New Zealand",
      "alpha-2": "NZ",
    },
    {
      name: "Nicaragua",
      "alpha-2": "NI",
    },
    {
      name: "Niger",
      "alpha-2": "NE",
    },
    {
      name: "Nigeria",
      "alpha-2": "NG",
    },
    {
      name: "Niue",
      "alpha-2": "NU",
    },
    {
      name: "Norfolk Island",
      "alpha-2": "NF",
    },
    {
      name: "North Macedonia",
      "alpha-2": "MK",
    },
    {
      name: "Northern Mariana Islands",
      "alpha-2": "MP",
    },
    {
      name: "Norway",
      "alpha-2": "NO",
    },
    {
      name: "Oman",
      "alpha-2": "OM",
    },
    {
      name: "Pakistan",
      "alpha-2": "PK",
    },
    {
      name: "Palau",
      "alpha-2": "PW",
    },
    {
      name: "Palestine, State of",
      "alpha-2": "PS",
    },
    {
      name: "Panama",
      "alpha-2": "PA",
    },
    {
      name: "Papua New Guinea",
      "alpha-2": "PG",
    },
    {
      name: "Paraguay",
      "alpha-2": "PY",
    },
    {
      name: "Peru",
      "alpha-2": "PE",
    },
    {
      name: "Philippines",
      "alpha-2": "PH",
    },
    {
      name: "Pitcairn",
      "alpha-2": "PN",
    },
    {
      name: "Poland",
      "alpha-2": "PL",
    },
    {
      name: "Portugal",
      "alpha-2": "PT",
    },
    {
      name: "Puerto Rico",
      "alpha-2": "PR",
    },
    {
      name: "Qatar",
      "alpha-2": "QA",
    },
    {
      name: "Réunion",
      "alpha-2": "RE",
    },
    {
      name: "Romania",
      "alpha-2": "RO",
    },
    {
      name: "Russian Federation",
      "alpha-2": "RU",
    },
    {
      name: "Rwanda",
      "alpha-2": "RW",
    },
    {
      name: "Saint Barthélemy",
      "alpha-2": "BL",
    },
    {
      name: "Saint Helena, Ascension and Tristan da Cunha",
      "alpha-2": "SH",
    },
    {
      name: "Saint Kitts and Nevis",
      "alpha-2": "KN",
    },
    {
      name: "Saint Lucia",
      "alpha-2": "LC",
    },
    {
      name: "Saint Martin (French part)",
      "alpha-2": "MF",
    },
    {
      name: "Saint Pierre and Miquelon",
      "alpha-2": "PM",
    },
    {
      name: "Saint Vincent and the Grenadines",
      "alpha-2": "VC",
    },
    {
      name: "Samoa",
      "alpha-2": "WS",
    },
    {
      name: "San Marino",
      "alpha-2": "SM",
    },
    {
      name: "Sao Tome and Principe",
      "alpha-2": "ST",
    },
    {
      name: "Saudi Arabia",
      "alpha-2": "SA",
    },
    {
      name: "Senegal",
      "alpha-2": "SN",
    },
    {
      name: "Serbia",
      "alpha-2": "RS",
    },
    {
      name: "Seychelles",
      "alpha-2": "SC",
    },
    {
      name: "Sierra Leone",
      "alpha-2": "SL",
    },
    {
      name: "Singapore",
      "alpha-2": "SG",
    },
    {
      name: "Sint Maarten (Dutch part)",
      "alpha-2": "SX",
    },
    {
      name: "Slovakia",
      "alpha-2": "SK",
    },
    {
      name: "Slovenia",
      "alpha-2": "SI",
    },
    {
      name: "Solomon Islands",
      "alpha-2": "SB",
    },
    {
      name: "Somalia",
      "alpha-2": "SO",
    },
    {
      name: "South Africa",
      "alpha-2": "ZA",
    },
    {
      name: "South Georgia and the South Sandwich Islands",
      "alpha-2": "GS",
    },
    {
      name: "South Sudan",
      "alpha-2": "SS",
    },
    {
      name: "Spain",
      "alpha-2": "ES",
    },
    {
      name: "Sri Lanka",
      "alpha-2": "LK",
    },
    {
      name: "Sudan",
      "alpha-2": "SD",
    },
    {
      name: "Suriname",
      "alpha-2": "SR",
    },
    {
      name: "Svalbard and Jan Mayen",
      "alpha-2": "SJ",
    },
    {
      name: "Sweden",
      "alpha-2": "SE",
    },
    {
      name: "Switzerland",
      "alpha-2": "CH",
    },
    {
      name: "Syrian Arab Republic",
      "alpha-2": "SY",
    },
    {
      name: "Taiwan, Province of China",
      "alpha-2": "TW",
    },
    {
      name: "Tajikistan",
      "alpha-2": "TJ",
    },
    {
      name: "Tanzania, United Republic of",
      "alpha-2": "TZ",
    },
    {
      name: "Thailand",
      "alpha-2": "TH",
    },
    {
      name: "Timor-Leste",
      "alpha-2": "TL",
    },
    {
      name: "Togo",
      "alpha-2": "TG",
    },
    {
      name: "Tokelau",
      "alpha-2": "TK",
    },
    {
      name: "Tonga",
      "alpha-2": "TO",
    },
    {
      name: "Trinidad and Tobago",
      "alpha-2": "TT",
    },
    {
      name: "Tunisia",
      "alpha-2": "TN",
    },
    {
      name: "Turkey",
      "alpha-2": "TR",
    },
    {
      name: "Turkmenistan",
      "alpha-2": "TM",
    },
    {
      name: "Turks and Caicos Islands",
      "alpha-2": "TC",
    },
    {
      name: "Tuvalu",
      "alpha-2": "TV",
    },
    {
      name: "Uganda",
      "alpha-2": "UG",
    },
    {
      name: "Ukraine",
      "alpha-2": "UA",
    },
    {
      name: "United Arab Emirates",
      "alpha-2": "AE",
    },
    {
      name: "United Kingdom",
      "alpha-2": "GB",
    },
    {
      name: "United States of America",
      "alpha-2": "US",
    },
    {
      name: "United States Minor Outlying Islands",
      "alpha-2": "UM",
    },
    {
      name: "Uruguay",
      "alpha-2": "UY",
    },
    {
      name: "Uzbekistan",
      "alpha-2": "UZ",
    },
    {
      name: "Vanuatu",
      "alpha-2": "VU",
    },
    {
      name: "Venezuela (Bolivarian Republic of)",
      "alpha-2": "VE",
    },
    {
      name: "Viet Nam",
      "alpha-2": "VN",
    },
    {
      name: "Virgin Islands (British)",
      "alpha-2": "VG",
    },
    {
      name: "Virgin Islands (U.S.)",
      "alpha-2": "VI",
    },
    {
      name: "Wallis and Futuna",
      "alpha-2": "WF",
    },
    {
      name: "Western Sahara",
      "alpha-2": "EH",
    },
    {
      name: "Yemen",
      "alpha-2": "YE",
    },
    {
      name: "Zambia",
      "alpha-2": "ZM",
    },
    {
      name: "Zimbabwe",
      "alpha-2": "ZW",
    },
  ];

  let countryFullName = "";

  countryList.every((element) => {
    if (element["alpha-2"] === country) {
      countryFullName = element.name;
      return false;
    }
    return true;
  });

  if (countryFullName !== "") {
    return countryFullName;
  } else {
    return country;
  }
}

/* Free to use animated SVG weather icons. Handcrafted by [Bas Milius](https://bas.dev). */
